<div
  class="flex items-start gap-3 p-4 rounded-md text-sm max-w-2xl bg-[#F7F7F7]"
  [ngClass]="wrapperClasses"
>
  <div [ngClass]="iconWrapperClasses">
    <i [class]="iconClass" style="font-size: 1rem;"></i>
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
